import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Particle from "../Particle";
import { AiOutlineMail, AiOutlinePhone } from "react-icons/ai";
import { FaMapMarkerAlt, FaPaperPlane, FaCheckCircle } from "react-icons/fa";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.message) return;

    setIsLoading(true);
    // Simulate API request delay
    setTimeout(() => {
      setIsLoading(false);
      setIsSubmitted(true);
      setFormData({ name: "", email: "", subject: "", message: "" });
    }, 1500);
  };

  return (
    <Container fluid className="contact-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Get In <strong className="purple">Touch </strong>
        </h1>
        <p style={{ color: "white", paddingBottom: "20px" }}>
          Feel free to reach out to me for collaborations, job opportunities, or just to say hello!
        </p>

        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          {/* Contact Details Column */}
          <Col md={5} className="contact-info-col">
            <div className="contact-card">
              <div className="contact-info-item">
                <div className="contact-icon-wrapper">
                  <AiOutlineMail className="contact-icon" />
                </div>
                <div>
                  <h5 className="purple">Email</h5>
                  <a href="mailto:naveenkumar735854@gmail.com" className="contact-link">
                    naveenkumar735854@gmail.com
                  </a>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-icon-wrapper">
                  <AiOutlinePhone className="contact-icon" />
                </div>
                <div>
                  <h5 className="purple">Phone</h5>
                  <a href="tel:+916383322923" className="contact-link">
                    +91 6383322923
                  </a>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-icon-wrapper">
                  <FaMapMarkerAlt className="contact-icon" />
                </div>
                <div>
                  <h5 className="purple">Location</h5>
                  <p className="contact-text">Chennai, India</p>
                </div>
              </div>
            </div>
          </Col>

          {/* Form Column */}
          <Col md={6} className="contact-form-col">
            <div className="contact-form-wrapper">
              {isSubmitted ? (
                <div className="submission-success">
                  <FaCheckCircle className="success-icon animate-success" />
                  <h3>Thank You!</h3>
                  <p>Your message has been sent successfully. I will get back to you shortly.</p>
                  <Button
                    variant="primary"
                    onClick={() => setIsSubmitted(false)}
                    style={{ marginTop: "20px" }}
                  >
                    Send Another Message
                  </Button>
                </div>
              ) : (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="formName">
                    <Form.Label className="contact-label">Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Enter your name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="contact-input"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label className="contact-label">Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Enter your email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="contact-input"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formSubject">
                    <Form.Label className="contact-label">Subject</Form.Label>
                    <Form.Control
                      type="text"
                      name="subject"
                      placeholder="Enter subject (optional)"
                      value={formData.subject}
                      onChange={handleChange}
                      className="contact-input"
                    />
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="formMessage">
                    <Form.Label className="contact-label">Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="message"
                      rows={5}
                      placeholder="Write your message here..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                      className="contact-input"
                    />
                  </Form.Group>

                  <div className="d-grid">
                    <Button
                      variant="primary"
                      type="submit"
                      disabled={isLoading}
                      className="contact-submit-btn"
                    >
                      {isLoading ? (
                        <>Sending Message...</>
                      ) : (
                        <>
                          Send Message &nbsp;
                          <FaPaperPlane style={{ fontSize: "0.85em" }} />
                        </>
                      )}
                    </Button>
                  </div>
                </Form>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Contact;
